export default __webpack_public_path__ + "static/media/bfp.e9230f4d.png";